<template>
    <el-dialog custom-class="move_coll_dialog" :model-value="show" title="移动到收藏夹" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="move_coll_dialog_content" v-loading="loading">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-shoucang1"></i></div>
            <h1>移动到收藏夹</h1>
            <h2>请选择目标收藏夹</h2>
            <div class="search_input">
                <i class="iconfont icon-sousuo"></i>
                <input type="text" placeholder="搜索收藏夹" v-model.trim="keyword" />
            </div>
            <ul class="list scrollbar">
                <li class="list_item" v-for="item in listC" :key="item.id">
                    <span class="name">{{ item.favoriteName }}</span>
                    <span class="num">({{ item.total }})</span>
                    <div class="btn" @click="onColl(item)">收藏</div>
                </li>
                <li v-if="!listC.length"><p class="no">暂无收藏夹</p></li>
            </ul>
            <div class="new_box">
                <div class="btn">
                    <i class="iconfont icon-gantanhao"></i>
                    <p>
                        当前文章在“<span>{{ currentColl?.favoriteName }}</span
                        >”
                    </p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { Close } from "@element-plus/icons-vue";
import { cloneDeep } from "loadsh";
import { apiFavoriteArticleAdd } from "@/request/api";
import { ElMessage } from "element-plus";

const props = defineProps({
    show: { type: Boolean, default: false },
    row: { type: Object, default: {} },
    favoriteList: { type: Array, default: [] },
});
const emits = defineEmits(["close", "success"]);
const currentColl = computed(() => {
    return props.favoriteList.find((item) => item.id === props.row.favoriteId);
});
const keyword = ref("");
const listC = computed(() => {
    const res = cloneDeep(props.favoriteList);
    // 根据关键字过滤
    if (keyword.value) {
        return res.filter((item) => {
            return item.favoriteName.includes(keyword.value);
        });
    }
    return res;
});
const loading = ref(false);

// 点击收藏
async function onColl(row) {
    loading.value = true;
    try {
        const params = {
            articleId: props.row.articleId,
            weeklyId: props.row.weeklyId,
            id: row.id,
        };
        const { code } = await apiFavoriteArticleAdd(params);
        if (code !== "0") return;
        ElMessage.success("移动成功");
        handleClose();
        emits("success");
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    emits("close");
}
</script>

<style lang="scss">
.move_coll_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .move_coll_dialog_content {
        padding: 34px 34px 0 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .search_input {
            height: 48px;
            border-radius: 24px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            padding-left: 21px;
            margin-top: 16px;
            .iconfont {
                font-size: 26px;
                color: #979797;
            }
            input {
                height: 100%;
                line-height: 48px;
                background: none;
                flex: 1;
                padding: 0 20px;
                border: none;
                font-size: 18px;
            }
        }
        .list {
            margin-top: 16px;
            height: 240px;
            overflow-y: auto;
            border-bottom: 1px solid #d8d8d8;
            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                height: 48px;
                border-radius: 8px;
                padding-left: 16px;
                padding-right: 10px;
                transition: all 0.3s;
                p.no {
                    text-align: center;
                    display: block;
                    width: 100%;
                }
                .name {
                    font-size: 14px;
                    color: #2a2a2a;
                }
                .num {
                    font-size: 14px;
                    color: #727272;
                }
                .btn {
                    position: absolute;
                    height: 44px;
                    width: 64px;
                    background-color: var(--primary-color);
                    color: #fff;
                    text-align: center;
                    line-height: 44px;
                    border-radius: 8px;
                    top: 2px;
                    right: 2px;
                    cursor: pointer;
                    display: none;
                }
                &.list_item:hover {
                    background-color: #ffeee4;
                    .btn {
                        display: block;
                    }
                }
            }
        }
        .new_box {
            height: 56px;
            display: flex;
            align-items: center;
            .btn {
                width: 100%;
                height: inherit;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .iconfont {
                    color: var(--primary-color);
                    font-size: 20px;
                }
                p {
                    font-size: 18px;
                    padding-left: 8px;
                    span {
                        font-size: inherit;
                        color: var(--primary-color);
                    }
                }
            }
        }
    }
}
</style>
